import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import Loading from "../components/Loading";
import { TextField, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";
import {
  formatDate,
  formatearFechaDDMMYY,
  formatearFechayyyyMMdd
} from "../utils/dates";
import DateField from "../components/DateField";
import PDFReport from "../components/PDFreport";
import { FaFilePdf } from "react-icons/fa";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill
} from "react-icons/bs";

export const Anunciantes = () => {
  const [anunciantes, setAnunciantes] = useState([]);
  const [agregando, setAgregando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [contacto, setContacto] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(0);
  const [facturas, setFacturas] = useState([]);
  const sendRequest = useRequestHandler();
  const [fecha, setFecha] = useState(new Date());

  useEffect(() => {
    refrescarGrilla();
  }, []);

  const refrescarGrilla = () => {
    sendRequest(Servicios.ObtenerAnunciantes, [], data => {
      setAnunciantes(data?.data);
    });
  };

  const obtenerFacturas = id => {
    sendRequest(Servicios.ObtenerFacturas, [id], data => {
      setFacturas(
        data?.data.map(x => {
          return {
            ...x,
            fechaDesde: formatearFechaDDMMYY(x.fechaDesde),
            fechaHasta: formatearFechaDDMMYY(x.fechaHasta)
          };
        })
      );
    });
  };

  const limpiarForm = () => {
    setNombre("");
    setContacto("");
    setObservaciones("");
  };

  const eliminarAnunciante = id => {
    sendRequest(Servicios.EliminarAnunciante, [id], refrescarGrilla);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 10 },
    {
      field: "nombre",
      headerName: "Nombre",
      flex: 30,
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setIdEditando(params.row.id);
          setNombre(params.row.nombre);
          setContacto(params.row.contacto);
          setObservaciones(params.row.observaciones);
          obtenerFacturas(params.row.id);
        };

        return (
          <a href="#" onClick={onClick}>
            {params.row.nombre}
          </a>
        );
      }
    },
    { field: "contacto", headerName: "Contacto", flex: 30 },
    { field: "observaciones", headerName: "Observaciones", flex: 30 },
    {
      field: "actionEdit",
      headerName: "",
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setIdEditando(params.row.id);
          setNombre(params.row.nombre);
          setContacto(params.row.contacto);
          setObservaciones(params.row.observaciones);
          obtenerFacturas(params.row.id);
        };

        return <EditIcon className="action-icon" onClick={onClick} />;
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      renderCell: params => {
        const onClick = e => {
          if (window.confirm("¿Confirmas eliminar el Anunciante?")) {
            eliminarAnunciante(params?.row?.id);
          }
        };

        return <DeleteIcon className="action-icon" onClick={onClick} />;
      }
    }
  ];

  const customButton = row => {
    return <PDFReport data={[row]}></PDFReport>;
  };

  const columnsFacturas = [
    { field: "id", headerName: "ID", flex: 10 },
    { field: "fechaDesde", headerName: "Desde", flex: 30 },
    { field: "fechaHasta", headerName: "Hasta", flex: 30 },
    { field: "nivelContratacionNombre", headerName: "Nivel", flex: 30 },
    { field: "importe", headerName: "Importe", flex: 30 },
    {
      field: "actionPDF",
      headerName: "",
      sortable: false,
      renderCell: params => {
        return customButton(params.row);
      }
    }
  ];

  const nuevaFactura = fecha => {
    sendRequest(
      Servicios.FacturarAnunciante,
      [idEditando, formatearFechayyyyMMdd(new Date(fecha))],
      () => {
        obtenerFacturas(idEditando);
      }
    );
  };

  const handleGuardar = () => {
    if (editando) {
      sendRequest(
        Servicios.ModificarAnunciante,
        [
          {
            id: idEditando,
            nombre: nombre,
            contacto: contacto,
            observaciones: observaciones
          }
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    } else {
      sendRequest(
        Servicios.CrearAnunciante,
        [
          {
            nombre,
            contacto,
            observaciones
          }
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    }
  };

  return (
    <>
      <>
        {!agregando ? (
          <>
            <div className="flex items-center justify-between gap-4 p-2">
              <div className="page-header">
                <h4 className="page-title">Anunciantes</h4>
              </div>

              <div>
                <Button
                  variant={"contained"}
                  onClick={() => {
                    setAgregando(true);

                    setIdEditando(0);
                    setNombre("");
                    setContacto("");
                    setObservaciones("");
                  }}
                >
                  Agregar
                </Button>
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="grid-wrapper w-full p-2">
              {anunciantes?.length > 0 ? (
                <DataGrid
                  rows={anunciantes}
                  columns={columns}
                  checkboxSelection={false}
                />
              ) : (
                <h5>No se encontraron resultados</h5>
              )}
            </div>
          </>
        ) : (
          <div className="card-modern">
            <div className="flex flex-col gap-3">
              <div className="flex items-center justify-between gap-4 p-2">
                <div className="page-header">
                  <h4 className="page-title">
                    {editando ? "Modificar Anunciante" : "Nuevo Anunciante"}
                  </h4>
                </div>
              </div>
              <div className="mb-3 p-2">
                <TextField
                  className="w-full"
                  size="small"
                  label="Nombre"
                  value={nombre}
                  onChange={e => setNombre(e.target.value)}
                />
              </div>
              <div className="mb-3 p-2">
                <TextField
                  className="w-full"
                  size="small"
                  label="Contacto"
                  value={contacto}
                  onChange={e => setContacto(e.target.value)}
                />
              </div>
              <div className="mb-3 p-2">
                <TextField
                  className="w-full"
                  size="small"
                  label="Observaciones"
                  value={observaciones}
                  onChange={e => setObservaciones(e.target.value)}
                />
              </div>
              <hr className="border-gray-200 dark:border-gray-700 my-4" />
              <div className="flex items-center gap-4">
                <h5>Facturas</h5>
                <div className="flex-1"></div>
                <div
                  id="datepicker-programacion"
                  className="datepicker text-end"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-auto">
                      <DateField value={fecha} onChange={setFecha} />
                    </div>
                  </div>
                </div>
                <div className="flex-none">
                  <Button
                    variant={"contained"}
                    onClick={() => nuevaFactura(fecha)}
                  >
                    Nueva factura
                  </Button>
                </div>
              </div>
              <div className="grid-wrapper w-full p-2">
                {facturas?.length > 0 ? (
                  <DataGrid
                    rows={facturas}
                    columns={columnsFacturas}
                    checkboxSelection={false}
                  />
                ) : (
                  <h5>No se encontraron facturas</h5>
                )}
              </div>
            </div>
            <hr className="border-gray-200 dark:border-gray-700 my-4" />
            <div className="flex items-center justify-center gap-4 w-auto">
              <div className="flex-1 text-start">
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    limpiarForm();
                    setEditando(false);
                    setAgregando(false);
                  }}
                >
                  Cancelar
                </Button>
              </div>
              <div className="flex-1 text-end">
                <Button variant={"contained"} onClick={handleGuardar}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default withAuthenticationRequired(Anunciantes, {
  onRedirecting: () => <Loading />
});
